import { CustomFilterField, CustomFilterType, CustomFilterOperator } from "../Shared/Models/CustomFilterModels";

export enum TROOrder {
    None,
    TROCode,
    OrderTitle,
    StartDate,
    EndDate
}

